<template>
  <aside :class="['control-sidebar control-sidebar-dark', state.sidebarOpen ? 'control-sidebar-open' : '']">
    <ul class="nav nav-tabs nav-justified control-sidebar-tabs">
      <li class="active">
        <a href="#adminTab" data-toggle="tab"><i class="fa fa-gears"></i></a>
      </li>
      <!--<li>
        <a href="#toolsTab" data-toggle="tab"><i class="fa fa-wrench"></i></a>
      </li>-->
    </ul>
    <div class="tab-content">
      <!-- ADMIN -->
      <div class="tab-pane active" id="adminTab">
        <h3 class="control-sidebar-heading">Administration</h3>
        <ul class="control-sidebar-menu">
          <li :class="{ active: $route.path === '/admin/user' }" v-if="user.admin.user">
           <router-link to="/admin/user">
              <i class="menu-icon fa fa-users"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Benutzer</h4>
                <p>Benutzerberechtigungen</p>
              </div>
           </router-link>
          </li>
          <li :class="{ active: $route.path === '/admin/role' }" v-if="user.admin.role">
            <router-link to="/admin/role" >
              <i class="menu-icon fa fa-id-card"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Rollen</h4>
                <p>Rollenmanagement</p>
              </div>
            </router-link>
          </li>
          <li :class="{ active: $route.path === '/admin/module' }" v-if="user.admin.module">
            <router-link to="/admin/module" >
              <i class="menu-icon fa fa-window-restore"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Module</h4>
                <p>Modulkonfiguration</p>
              </div>
            </router-link>
          </li>
          <li :class="{ active: $route.path === '/admin/navigation' }" v-if="user.admin.page">
            <router-link to="/admin/navigation" >
              <i class="menu-icon fa fa-bars"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Navigation</h4>
                <p>Menükonfiguration</p>
              </div>
            </router-link>
          </li>
          <li :class="{ active: $route.path === '/admin/charts' }" v-if="user.admin.chart">
            <router-link to="/admin/charts" >
              <i class="menu-icon fa fa-pie-chart"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Charts</h4>
                <p>Grafenkonfiguration</p>
              </div>
            </router-link>
          </li>
          <!--
          <li>
            <a href="admin-modules.html">
              <i class="menu-icon fa fa-window-restore"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Modules</h4>
                <p>Module Configurations</p>
              </div>
            </a>
          </li>
          <li>
            <a href="admin-navigation.html">
              <i class="menu-icon fa fa-bars"></i>
              <div class="menu-info">
                <h4 class="control-sidebar-subheading">Navigation</h4>
                <p>Main Menükonfiguration</p>
              </div>
            </a>
          </li>-->
        </ul>
      </div>
      <!-- TOOLS -->
      <div class="tab-pane" id="toolsTab">
        <form method="post">
          <h3 class="control-sidebar-heading">Tools</h3>
          <div class="form-group">
            <label class="control-sidebar-subheading">
              Report panel usage
              <input type="checkbox" class="pull-right" checked>
            </label>
            <p>Some information about this general settings option</p>
          </div>
          <div class="form-group">
            <label class="control-sidebar-subheading">
              Allow mail redirect
              <input type="checkbox" class="pull-right" checked>
            </label>
            <p>Other sets of options are available</p>
          </div>
          <div class="form-group">
            <label class="control-sidebar-subheading">
              Expose author name in posts
              <input type="checkbox" class="pull-right" checked>
            </label>
            <p>Allow the user to show his name in blog posts</p>
          </div>
          <h3 class="control-sidebar-heading">Other Settings</h3>
          <div class="form-group">
            <label class="control-sidebar-subheading">
              Show me as online
              <input type="checkbox" class="pull-right" checked>
            </label>
          </div>
          <div class="form-group">
            <label class="control-sidebar-subheading">
              Turn off notifications
              <input type="checkbox" class="pull-right">
            </label>
          </div>
          <div class="form-group">
            <label class="control-sidebar-subheading">
              Delete history
              <a href="javascript:void(0)" class="btn btn-danger btn-xs pull-right"><i
                  class="fa fa-trash-o"></i></a>
            </label>
          </div>
        </form>
      </div>
    </div>
  </aside>
</template>

<script>
  export default {
    props: ['state'],
    name: "ControlSidebar",
    data () {
      return {
      }
    },
    computed: {
      user () {
        return this.state.user
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
